@if (editableButtonIndex() === null) {
    <web-widget-breadcrumbs [widget]="widget()" [hideBreadcrumbs]="isZero" [isInSpecificSection]="isSpecific()" />
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div
                class="mb-20"
                cdkDropList
                [cdkDropListData]="form.buttonItems()"
                (cdkDropListDropped)="dropGroup($event)"
            >
                @for (button of form.buttonItems(); track $index; let i = $index) {
                    <div cdkDrag cdkDropListGroup [cdkDragData]="button">
                        <sp-control-handle
                            [controlHandleBtn]="form.buttonItems().length !== 1"
                            [controlHandleDisableDelete]="form.buttonItems().length === 1"
                            [controlHandleMainText]="button.label"
                            [controlHandleSubText]="getButtonSubText(button)"
                            [controlHandleSubTextWarning]="!button.link.url?.length"
                            (editActionEvent)="editButton(i)"
                            (removeActionEvent)="removeButton(i)"
                        >
                            <span cdkDragHandle></span>
                        </sp-control-handle>
                    </div>
                }
                @if (!isZero) {
                    <a class="dotted" (click)="addButton()">{{ "add" | translate }}</a>
                }
            </div>
            @if (form.buttonItems().length > 1 && !isSpecific()) {
                <div class="form-row mb-20">
                    <div class="form-group">
                        <label class="control-label col-xs-7">
                            {{ "control_content_indent" | translate }}
                        </label>
                        <div class="col-xs-5">
                            <div class="btn-group d-flex">
                                <sp-radio-group
                                    [selected]="form?.horizontalIndent().value()"
                                    [type]="ERadioGroupType.size"
                                    (changeSelectedEvent)="form.setHorizontalIndent($any($event))"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (!isSpecific()) {
                <div class="form-row">
                    <div class="form-group mb-10">
                        <div class="col-xs-12 device-toggle-wrapper">
                            <web-device-toggle />
                            @if (!isZero) {
                                <web-synchronize-style-toggle
                                    [active]="form.isSynchronized()"
                                    (click)="setSynchronizeStyle()"
                                />
                            }
                        </div>
                    </div>
                </div>
                @if (isDeviceDesktopSig()) {
                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ "desktop_device_hint" | translate }}
                        </p>
                    </div>
                    <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                }
                @if (isDeviceTabletSig()) {
                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ "tablet_device_hint" | translate }}
                        </p>
                    </div>
                    @if (form.isSynchronized()) {
                        @if (!isZero) {
                            <div class="form-row">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="form?.horizontalAlign().value()"
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="setHorizontalAlign($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    } @else {
                        @if (!isZero) {
                            <div class="form-row">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="
                                                form?.tabletHorizontalAlign().value() ?? form?.horizontalAlign().value()
                                            "
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="form.setTabletHorizontalAlign($any($event))"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    }
                }
                @if (isDeviceMobileSig()) {
                    <div class="form-group mb-0">
                        @if (isZero) {
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "mobile_zero_device_hint" | translate }}
                            </p>
                        }
                        @if (!isZero) {
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "mobile_device_hint" | translate }}
                            </p>
                        }
                    </div>
                    @if (form.isSynchronized()) {
                        @if (!isZero) {
                            <div class="form-row">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="form?.horizontalAlign().value()"
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="setHorizontalAlign($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    } @else {
                        @if (!isZero) {
                            <div class="form-row">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="
                                                form?.mobileHorizontalAlign().value() ?? form?.horizontalAlign().value()
                                            "
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="form.setMobileHorizontalAlign($any($event))"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    }
                }
                <ng-template #desktopSettings>
                    @if (!isZero) {
                        <div class="form-row">
                            <div class="form-group">
                                <label class="control-label col-xs-7">
                                    {{ "control_content_alignment" | translate }}
                                </label>
                                <div class="col-xs-5">
                                    <sp-radio-group
                                        [selected]="form?.horizontalAlign().value()"
                                        [type]="ERadioGroupType.horizontalPosition"
                                        (changeSelectedEvent)="setHorizontalAlign($event)"
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </ng-template>
                @if (!isZero) {
                    <div class="form-group mb-0">
                        <div class="col-xs-12">
                            <hr class="panel-options-divider" />
                        </div>
                    </div>
                }
            }
            @if (isZero) {
                <sp-extended-position-signal-settings
                    [position]="zeroPosition()"
                    [isMobile]="isDeviceMobileSig()"
                    [isTablet]="isDeviceTabletSig()"
                    [parentId]="widget().columnId"
                    (valueChangeEvent)="zeroForm.setPosition($event)"
                />
            } @else {
                <web-widget-position-settings
                    [isSynchronized]="form.isSynchronized()"
                    [isTablet]="isDeviceTabletSig()"
                    [isMobile]="isDeviceMobileSig()"
                    [widgetId]="widget().id"
                    [columnId]="widget().columnId"
                    [position]="defaultPosition()"
                    (positionChange)="onDefaultPositionChange($any($event))"
                />
            }
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>
            @if (isZero) {
                <web-widget-extended-hide-settings
                    [hideOnDesktop]="form?.hideOnDesktop().value()"
                    [hideOnTablet]="form?.hideOnTablet().value()"
                    [hideOnMobile]="form?.hideOnMobile().value()"
                    (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                    (hideOnTabletChange)="form.setHideOnTablet($event)"
                    (hideOnMobileChange)="form.setHideOnMobile($event)"
                />
            } @else {
                <web-widget-hide-settings
                    [hideOnDesktop]="form?.hideOnDesktop().value()"
                    [hideOnMobile]="form?.hideOnMobile().value()"
                    [hideOnTablet]="form?.hideOnTablet().value()"
                    (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                    (hideOnTabletChange)="form.setHideOnTablet($event)"
                    (hideOnMobileChange)="form.setHideOnMobile($event)"
                />
            }
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>
            @if (!isSpecific()) {
                <div class="form-row">
                    <sp-animation-settings-signal-legacy
                        [animation]="form?.animation().value()"
                        (valueChangeEvent)="form.setAnimation($event)"
                    />
                </div>
            }
            <div [class.mt-20]="!isSpecific()">
                <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
            </div>
        </div>
    </div>
} @else {
    <web-button-settings
        [isSpecificWidget]="isSpecific()"
        [isZeroWidget]="isZero"
        [form]="form"
        [index]="editableButtonIndex()"
        (saveEvent)="saveButtonSettings()"
        (cancelEvent)="cancelButtonSettings()"
    />
}
